"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ownership$ = exports.Ownership$outboundSchema = exports.Ownership$inboundSchema = void 0;
exports.ownershipToJSON = ownershipToJSON;
exports.ownershipFromJSON = ownershipFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.Ownership$inboundSchema = z.object({
    company_owned: z.boolean(),
    overseas_owned: z.boolean(),
    social_housing: z.boolean(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "company_owned": "companyOwned",
        "overseas_owned": "overseasOwned",
        "social_housing": "socialHousing",
    });
});
/** @internal */
exports.Ownership$outboundSchema = z.object({
    companyOwned: z.boolean(),
    overseasOwned: z.boolean(),
    socialHousing: z.boolean(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        companyOwned: "company_owned",
        overseasOwned: "overseas_owned",
        socialHousing: "social_housing",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Ownership$;
(function (Ownership$) {
    /** @deprecated use `Ownership$inboundSchema` instead. */
    Ownership$.inboundSchema = exports.Ownership$inboundSchema;
    /** @deprecated use `Ownership$outboundSchema` instead. */
    Ownership$.outboundSchema = exports.Ownership$outboundSchema;
})(Ownership$ || (exports.Ownership$ = Ownership$ = {}));
function ownershipToJSON(ownership) {
    return JSON.stringify(exports.Ownership$outboundSchema.parse(ownership));
}
function ownershipFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Ownership$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Ownership' from JSON`);
}
//# sourceMappingURL=ownership.js.map